<template>
    <div class="apay-overview" v-if="isAPayPayment">
        <img src="@/assets/img/apple-pay.svg" alt="Apple Pay" />

        <div class="apay-overview__container">
            <div class="apay-overview__row">
                <span class="apay-overview__method">Apple Pay</span>

                <span class="apay-overview__price" tabindex="0">
                    {{ installments || 1 }} x
                    <small v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import translationParameterHelper from '@/config/lang/helpers/translationParameterHelper.js';

export default {
components: {

},

computed: {
  ...mapGetters({
      installments: 'payment/getInstallmentNumberOfPayments',
      installmentPrice: 'payment/getFormattedInstallmentPrice',
      paymentType: 'payment/getSelectedPaymentTypeId',
  }),
  numberOfInstallments: {
      get: (self) =>
          self.$store.getters['payment/getInstallmentNumberOfPayments'],
      set(value) {
          this.$store.commit('payment/setNumberOfInstallments', value);
      },
  },

  fullName() {
      //Create ApplePay Module to do this
      return this.$store.state.googlePayPayment.selectedCard.info.billingAddress.name;
  },

  cardPanLastFour() {
      //Create ApplePay Module to do this
      return this.$store.state.googlePayPayment.selectedCard.info.cardDetails;
  },

  isAPayPayment: (self) => self.$store.state.payment.PaymentType === 102,
},

methods: {
  getPaymentMethodTranslationParameterName() {
      return translationParameterHelper.getPaymentMethodTranslationParameterName(
          this.selectedPaymentMethod.PaymentType
      );
  },
},
};
</script>

<style lang="scss" scoped>
    .apay-overview {
        display: flex;
        align-items: center;

        img {
            margin-right: 20px;
        }

        &__container {
            display: flex;
            flex-direction: column;
            width: 100%;
            overflow: hidden;
        }

        &__row {
            display: flex;
            justify-content: space-between;

            span,
            small {
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                color: #000000;
            }
        }
        
        &__card {}
        &__method {}

        &__fullname {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1 0;
        }

        &__price {
            text-align: right;
            flex: 1 0;
        }

    }
</style>
